import React, { useEffect , useState } from "react"
import { Container } from "react-bootstrap"
import HTMLReactParser from 'html-react-parser';
//import ScrollAnimation from "react-animate-on-scroll";
import axios from "axios";
import "./Counter.scss"

const Counter = (props) => { 
  const [renderComponent, setRenderComponent] = useState(false);
    useEffect(()=>{
      let url = `${process.env.GATSBY_STRAPI_SRC}/google-review-reviews`
      window.addEventListener("mousemove", () => {
          if (renderComponent === false) {
              setRenderComponent(true)
          }
      })
      window.addEventListener("keypress", () => {
          if (renderComponent === false) {
              setRenderComponent(true)
          }
      })
      window.addEventListener("touchmove", () => {
          if (renderComponent === false) {
              setRenderComponent(true)
          }
      })
      
    })

    return (
        <section className={`counter sec-pdy-120 ${props.page === 'Home' ? 'home-counter' : 'landing-counter'}`}>
            <Container>
                <div className="counter-wrapper">
                    <div className="row">
                    {props.stats && props.stats.map((stat, i) => {  
                        return (
                        <div className="col-12 col-md-6 col-xl-3">
                         <div className="record-wrap">
                            <div className="total-record">
                                <span className="count-heading h1"> 
                                {
                                    stat.Value == "google_review_average" ? `${props.averageRating}/5` : stat.Value
                                }
                                </span>
                                <p className="text-sm mb-0">
                                {
                                    stat.Value == "google_review_average" ? <p>{props.averageRating} average Google Review score</p>: HTMLReactParser(stat.Content.replace(/\n/g,'<br />'))
                                } 
                             </p>
                            </div>
                            </div>
                        </div>
                        )
                    })}
                    </div>
                    
                </div>
          
            </Container>
            
        </section>
    )
};
export default Counter